<template>
  <div class="nzsc-splash">
    <div class="nzsc-splash__top">
      <img
        class="nzsc-splash__logo-nzsc"
        src="@/assets/images/advertisement/splash/logo/naezipscan_logo.svg"
        alt="내집스캔"
      />
      <template v-if="isMisoAd">
        <div class="nzsc-splash__logo-sep"></div>
        <img
          class="nzsc-splash__logo-miso"
          src="@/assets/images/advertisement/splash/logo/miso_logo.svg"
          alt="미소"
        />
      </template>
    </div>

    <div class="nzsc-splash__bottom">
      <!-- 전체 이미지 타입: miso_cleaning -->
      <template v-if="isWholeImgType">
        <div class="nzsc-splash__whole-img">
          <img
            src="@/assets/images/advertisement/splash/miso/cleaning/whole_img.svg"
            alt="입주 청소"
          />
        </div>
      </template>

      <!-- 누끼 타입 -->
      <template v-else>
        <div class="nzsc-splash__nukki">
          <p class="nzsc-splash__nukki-sub">{{ subText }}</p>
          <p
            class="nzsc-splash__nukki-main"
            v-html="mainText"
          ></p>
          <div class="nzsc-splash__nukki-img">
            <img
              :src="nukkiImgSrc"
              alt=""
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { AD_TYPE, MISO_SUBTYPES } from "./adTypes";

import rentCardObj from "@/assets/images/advertisement/splash/rent_card/obj_img.svg";
import houseLoanObj from "@/assets/images/advertisement/splash/house_loan/obj_img.svg";
import misoMovingObj from "@/assets/images/advertisement/splash/miso/moving/obj_img.svg";
import misoInternetObj from "@/assets/images/advertisement/splash/miso/internet/obj_img.svg";

const AD_CONFIG = {
  [AD_TYPE.RENT_CARD]: {
    subText: "이번 달 월세 낼 돈 없다면?",
    mainText: '<span class="highlight-blue">월세 카드결제</span>로 고민 끝!',
    nukkiImg: rentCardObj,
  },
  [AD_TYPE.HOUSE_LOAN]: {
    subText: "내집스캔에서 찾은 최저 주담대 상담 받기",
    mainText: '이번 달 <span class="highlight-blue">최저 금리 주담대</span>는 뭘까?',
    nukkiImg: houseLoanObj,
  },
  [AD_TYPE.MISO_MOVING]: {
    subText: "이사 전문 업체 비교 견적 받고",
    mainText: "이사 비용 30만원 아껴요",
    nukkiImg: misoMovingObj,
  },
  [AD_TYPE.MISO_INTERNET]: {
    subText: "통신사별 현금 혜택까지 한 눈에 비교!",
    mainText: "인터넷 가입하면 최대 48만원 지급",
    nukkiImg: misoInternetObj,
  },
};

export default {
  name: "SplashAdComponent",
  computed: {
    ...mapGetters("advertisementStore", ["resolvedAdType"]),
    isMisoAd() {
      return MISO_SUBTYPES.includes(this.resolvedAdType);
    },
    isWholeImgType() {
      return this.resolvedAdType === AD_TYPE.MISO_CLEANING;
    },
    adConfig() {
      return AD_CONFIG[this.resolvedAdType] || null;
    },
    subText() {
      return this.adConfig?.subText || "";
    },
    mainText() {
      return this.adConfig?.mainText || "";
    },
    nukkiImgSrc() {
      return this.adConfig?.nukkiImg || "";
    },
  },
};
</script>

<style scoped>
.nzsc-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 99999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.nzsc-splash__top {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
}

.nzsc-splash__logo-nzsc {
  height: 47px;
}

.nzsc-splash__logo-sep {
  width: 26px;
  height: 1px;
  background: #d2d2d2;
  margin: 18px 0;
}

.nzsc-splash__logo-miso {
  height: 34px;
}

.nzsc-splash__bottom {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.nzsc-splash__nukki {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;
}

.nzsc-splash__nukki-sub {
  font-size: 15px;
  font-weight: 400;
  line-height: normal;
  color: #606060;
  margin-bottom: 4px;
}

.nzsc-splash__nukki-main {
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  color: #121212;
  margin-bottom: 20px;
}

.nzsc-splash__nukki-main >>> .highlight-blue {
  color: #0080ff;
}

.nzsc-splash__nukki-img {
  width: 140px;
  height: 140px;
}

.nzsc-splash__nukki-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nzsc-splash__whole-img {
  width: 100%;
}

.nzsc-splash__whole-img img {
  width: 100%;
  display: block;
}
</style>
